import { DateFormatType, formatDate } from '../TimedEntrySeries';

export const getFormattedDateOrEmpty = (
    date: string | null | undefined,
    formatType: DateFormatType,
    locale: string,
): string => {
    return date ? formatDate(new Date(date), formatType, locale) : '';
};

export const getMonthAndYearFromDate = (utcDate: string) => {
    const date = new Date(utcDate);
    return { month: date.getMonth(), year: date.getFullYear() };
};
